import { createSlice } from "@reduxjs/toolkit";

// Type
type TypeDescriptor = {
  hbd: number;
  qed: number;
  tpsa: number;
  fsp3: number;
  wqed: number;
  logP: number;
  heavyAtomCount: number;
  molecularWeight: number;
  rotatableBondCount: number;
}

type TypeProductProperties = {
  id: string;
  cas: string;
  dbId: string;
  name: string;
  cxSmiles: string;
  iupacName: string;
  mdlNumber: string;
  description: string;
  descriptor: TypeDescriptor,
}

type TypeItem = {
  id: number,
  purity: number,
  quantity: number,
  productId: string,
  productType: string,
  prepackage: number,
  priceForOne: number,
  totalPrice: number,
  productProperties: TypeProductProperties;
}

type TypeProject = {
  id: number,
  name: string,
}

export type TypeData = {
  id: number;
  status: string;
  created: string;
  item: TypeItem[];
  currency: string;
  discount: number;
  finished: boolean;
  priceItems: number;
  priceTotal: number;
  project: TypeProject;
  priceShipping: number;
}

// Interface
interface IInterfaceState {
  loading: boolean;
  data?: TypeData[] | [];
  ordersByIdLoading: boolean;
}

const initialState: IInterfaceState = {
  data: [],
  loading: false,
  ordersByIdLoading: false,
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState: initialState,
  reducers: {
    getListOrders: (state, action) => {
      state.loading = true;
    },
    getListOrdersError: (state) => {
      state.loading = false;
    },
    getListOrdersSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },

    getOrderById: (state, action) => {
      state.ordersByIdLoading = true;
    },
    getOrderByIdError: (state) => {
      state.ordersByIdLoading = false;
    },
    getOrderByIdSuccess: (state, action) => {
      state.ordersByIdLoading = false;
      state.data = action.payload;
    },
  }
});

export const {
  getListOrders,
  getListOrdersError,
  getListOrdersSuccess,

  getOrderById,
  getOrderByIdError,
  getOrderByIdSuccess,
} = ordersSlice.actions;

export default ordersSlice.reducer;
